<template>
  <v-app-bar
    app
  >
    <v-dialog
      v-model="passwordChangeDialog"
      max-width="400px"
      :persistent="updatingPassword"
    >
      <v-card>
        <v-card-title>Change Password</v-card-title>
        <v-card-text>
          <v-row no-gutters class="flex-column">
            <v-col class="py-4">
              <v-text-field
                v-model="oldPassword"
                type="password"
                label="Current Password"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col class="pt-4">
              <v-text-field
                v-model="newPassword"
                type="password"
                label="New Password"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col class="pt-4">
              <v-text-field
                v-model="newPasswordConfirm"
                type="password"
                label="Confirm New Password"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" @click="passwordChangeDialog = false" :disabled="updatingPassword">Cancel</v-btn>
          <v-btn color="primary" :loading="updatingPassword" @click="updatePassword">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
      transition="slide-y-transition"
      bottom
      right
      offset-y
      class="mr-5"
      nudge-width="120"
    >
      <template v-slot:activator="{on}">
        <v-btn
          v-on="on"
          text
          style="height: 100%;"
        >
          <v-img src="https://www.gravatar.com/avatar/2?d=mp" width="40" height="40" class="mr-2" />
          <span>{{ user.first_name }}</span>
        </v-btn>

        <router-link v-if="isSystemAdminOrEmployee" class="mr-3" :to="{ name: 'system-admin'}" style="text-decoration: none;">
          <v-btn
            color="secondary"
            elevation="3"
            large
            icon
          >
            <v-icon dark>mdi-cog</v-icon>
          </v-btn>
        </router-link>
      </template>
      <v-list class="py-0">
        <v-subheader>{{ user.full_name }}</v-subheader>
        <v-list-item :to="{name: 'profile'}">
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{name: 'billing'}">
          <v-list-item-icon>
            <v-icon>mdi-credit-card</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Billing</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="passwordChangeDialog = true">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Change Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',
  data: () => ({
    passwordChangeDialog: false,
    oldPassword: null,
    newPassword: null,
    newPasswordConfirm: null,
    updatingPassword: false
  }),
  watch: {
    passwordChangeDialog (newVal) {
      if(newVal) {
        this.oldPassword = null
        this.newPassword = null
        this.newPasswordConfirm = null
        this.updatingPassword = false
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    isSystemAdminOrEmployee() {
      return this.$store.getters.canAccessSystemAdminSettings;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logoutUser');
    },
    updatePassword() {
      if(!this.oldPassword) {
        this.$swal.fire('Current Password Required', 'Please enter your existing password', 'error')
        return
      }
      if(!this.newPassword) {
        this.$swal.fire('New Password Required', 'Please enter your new password', 'error')
        return
      }
      if(this.newPassword.length < 5) {
        this.$swal.fire('Password Too Short', 'Please make your password longer than 4 characters', 'error')
        return
      }
      if(this.newPassword !== this.newPasswordConfirm) {
        this.$swal.fire('Passwords Must Match', 'Please make sure your new password matches the confirmation', 'error')
        return
      }

      let params = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        newPasswordConfirm: this.newPasswordConfirm
      }

      this.updatingPassword = true;
      this.$http.post('users/' + this.user.id + '/change-password', params)
        .then(() => {
          this.$swal.fire('Updated', 'Your password has been updated', 'success')
          this.passwordChangeDialog = false
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error updating your password. Please make sure your old password is correct.', 'error')
        })
        .finally(() => {
          this.updatingPassword = false
        })
    }
  }
}
</script>